export const QA_NAME_LISTING_PROFILE_PUBLISHINGS_OPEN_AD =
  'listingPublishingOpenAd'

export const LISTING_PROFILE_PUBLISHINGS_ROW_ACTIONS_CONFIG = {
  getOnClickProps: item => item,
}
